// src/App.js
import React from "react";
import MainRoutes from "./routes/MainRoutes";
import { ThemeProvider } from "@emotion/react";
import { theme } from "./config/theme";
import { Container } from "@mui/material";
import { AuthProvider } from "./context/AuthContext";
import { SnackbarProvider } from "notistack";
import { AppContextProvider } from "./context/AppContext";
import DialogComp from "./components/shared/DialogComp";
import MainLayout from "./components/shared/MainLayout";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import ErrorBoundary from "./components/shared/ErrorBoundary";

const App = () => {
  return (
    <div
      // style={{ height: "100vh", overflow: "hidden" }}
      className="App"
    >
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <AuthProvider>
          <AppContextProvider>
            <ThemeProvider theme={theme}>
              <SnackbarProvider
                autoHideDuration={3000}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "center",
                }}
              >
                <Container
                  maxWidth={false}
                  sx={{ p: "0 !important", height: "100vh" }}
                >
                  <DialogComp />
                  <MainRoutes>
                    <MainLayout />
                  </MainRoutes>
                </Container>
              </SnackbarProvider>
            </ThemeProvider>
          </AppContextProvider>
        </AuthProvider>
      </LocalizationProvider>
    </div>
  );
};

export default App;
